export default __webpack_public_path__ + "static/media/fastclix_lancets.ee4138c3.webp";